import React from "react";
import T from 'prop-types';
import { Title } from "../../atoms";

import { FaChevronLeft } from 'react-icons/fa';

export const SideBackNav = ({ onClick, title, orderNumber, statusTitle, notes, ifNotes, isView,title2="" }) => {
   
    return (
        <div style={{position:'relative'}}>
            <div style={{padding:"20px 20px 0px 20px",marginTop:'-41px'}} className="backNavCls fixed" onClick={onClick}>
                <FaChevronLeft  className={'menuIconCls space-left'} color={'black'} size={38} />
                <div >
                    <Title text={title} className="backTextStyles" />
                </div>   
               
                <div className="space-left">
                    <Title text={statusTitle} className={""} />
                    <Title text={orderNumber} className={"details-order-label"} />
                </div>
            
                    {/* <Title text={title2} className="space-left2" /> */}
               
            </div>
           
            
        </div>
    );
};

SideBackNav.T = {
    onClick: T.func,
    title: T.bool,
};
